import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureRefFromUrl } from "./referral";

/** Remembers a creator ?ref= code from any shared InstaPass link. Renders nothing. */
export default function CreatorRefCapture() {
  const { search, pathname } = useLocation();
  useEffect(() => {
    if (!pathname.startsWith("/r/")) captureRefFromUrl(search);
  }, [search, pathname]);
  return null;
}
